export default __webpack_public_path__ + "static/media/barChart.15e74ac2.svg";